export function extractNamesArray(items: { name: string }[] | undefined | null): string[] {
    if (!items || items.length === 0) return [];
    return items.map(item => item.name);
}
